/**
* @ngdoc service
* @name  sharebase.sbUserGroupsDataStore
* 
* @description 
* A datastore used to retrieve ShareBase user groups
**/
export function UserGroupsDataStoreFactory(
	$filter:ng.IFilterService, 
	sbUserGroupsService
) {
	var _userGroups = [];

	return {
		/**
		* @ngdoc method
		* @name sbUserGroupsDataStore#getUserGroups
		* @methodOf sharebase.sbUserGroupsDataStore
		* @kind function
		*
		* @description
		* Gets a collection of user groups
		*
		* @returns {Deferred} A promise that will resolve with a collection of user groups
		* 
		*/
		getUserGroups,

		/**
		* @ngdoc property
		* @name sbUserGroupsDataStore#userGroups
		* @propertyOf sharebase.sbUserGroupsDataStore
		* @kind property
		*
		* @description
		* A collection of user groups
		* 
		* @returns {array} An array of user groups
		*/
		get userGroups() { return _userGroups; }
	};

	function getUserGroups(systemName) {
		return sbUserGroupsService
			.getUserGroups(systemName)
			.then(function (response) {
				_userGroups = $filter('orderBy')(response, 'UserGroupName');
				return response;
			});
	}
}

UserGroupsDataStoreFactory.$inject = [
	'$filter',
	'sbUserGroupsService'
];


// WEBPACK FOOTER //
// ./src/sharebase/dataStores/userGroupsDataStore.ts